export class FufSizeTooLargeError extends Error {}
